const buttonDefaultStyle = theme => ({
  textTransform: 'none',
  fontFamily: theme.tokens.ComponentBtnFontFamily,
  fontSize: theme.tokens.ComponentBtnFontSize,
  fontWeight: theme.tokens.ComponentBtnFontWeight,
  marginBottom: 0,
  textAlign: 'center',
  whiteSpace: 'nowrap',
  verticalAlign: 'middle',
  touchAction: 'manipulation',
  cursor: 'pointer',
  backgroundImage: 'none',
  border: '1px solid transparent',
  padding: theme.tokens.ComponentBtnSizeDefaultPadding,
  lineHeight: theme.tokens.ComponentBtnSizeDefaultLineHeight,
  borderRadius: theme.tokens.ComponentBtnSizeDefaultBorderRadius,
  userSelect: 'none',
  minWidth: 0,
  '& .MuiButton-startIcon': {
    marginRight: '0',
    marginLeft: '0'
  },
  '& .MuiButton-endIcon': {
    marginLeft: '0',
    marginRight: '0'
  },
  '&.MuiButtonBase-root': {
    gap: '8px'
  }
});
export default buttonDefaultStyle;